import { useLocation } from 'react-router-dom';

import { useFeatureIsOn } from 'src/common/growthbook';

export const useIsProductOverviewExperimentEnabled = () => {
  const location = useLocation();
  const isProductOverviewFeatureOn = useFeatureIsOn('add-product-overview-welcome');
  return isProductOverviewFeatureOn && location.pathname === '/welcome';
};
